import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import { formatMoney } from "../styles";

/**
 * The four-figure header (Invoice / Total / Paid / Balance) used by both
 * the Payment dialog and the Manage Lots dialog. It was duplicated in
 * full in each of them.
 */
const InvoiceSummary = ({ invoice }) => (
  <Grid container spacing={2} style={{ marginBottom: 20 }}>
    <Grid item xs={12} sm={3}>
      <Typography variant="caption" color="textSecondary">
        Invoice
      </Typography>
      <Typography variant="body2" style={{ fontWeight: 600 }}>
        {invoice?.invoice_no || "---"}
      </Typography>
    </Grid>

    <Grid item xs={12} sm={3}>
      <Typography variant="caption" color="textSecondary">
        Total Amount
      </Typography>
      <Typography variant="body2" style={{ fontWeight: 600 }}>
        {formatMoney(invoice?.total_amount)}
      </Typography>
    </Grid>

    <Grid item xs={12} sm={3}>
      <Typography variant="caption" color="textSecondary">
        Paid Amount
      </Typography>
      <Typography
        variant="body2"
        style={{ fontWeight: 600, color: "#2e7d32" }}
      >
        {formatMoney(invoice?.paid_amount)}
      </Typography>
    </Grid>

    <Grid item xs={12} sm={3}>
      <Typography variant="caption" color="textSecondary">
        Balance
      </Typography>
      <Typography
        variant="body2"
        style={{ fontWeight: 600, color: "#d32f2f" }}
      >
        {formatMoney(invoice?.balance_amount)}
      </Typography>
    </Grid>
  </Grid>
);

InvoiceSummary.propTypes = {
  invoice: PropTypes.object,
};

export default InvoiceSummary;
